import { Menu, MenuItem } from '@mui/material';

const menuStyles = {
  fontSize: '12px',
  color: 'rgba(73, 69, 79, 1)',
  justifyContent: 'center',
  borderBottom: '1px solid rgba(212, 220, 225, 1)',
  height: '40px',
};

interface HomeMenuProps {
  navFromMenu: (path: string) => void;
  anchorEl: null | HTMLElement;
  isOpen: boolean;
  close: () => void;
  width: number;
}

export const HomeMenu = ({
  navFromMenu,
  anchorEl,
  isOpen,
  close,
  width,
}: HomeMenuProps) => {
  return (
    <Menu
      id="basic-menu"
      anchorEl={anchorEl}
      open={isOpen}
      onClose={close}
      slotProps={{
        list: {
          'aria-labelledby': 'basic-button',
          sx: {
            width: width,
          },
        },
      }}
    >
      <MenuItem
        sx={{
          ...menuStyles,
        }}
        onClick={() => navFromMenu('/models')}
      >
        Home Search
      </MenuItem>
      <MenuItem
        sx={{
          ...menuStyles,
          paddingBottom: '0',
          borderBottom: 'unset',
        }}
        onClick={() => navFromMenu('/search/favorites')}
      >
        My Favorites
      </MenuItem>
    </Menu>
  );
};
